import { ContentContainer, ProductType, type Config, type Options } from "../core/types";
import type { IIframeProvider } from "../modal/IframeProvider";
import { ModalCoordinator } from "../modal/ModalCoordinator";
import type { ITrackingService } from "../tracking/ITrackingService";
import type { CalculatorData } from "../modal/types";

export abstract class BaseWidget {
    constructor(
        protected contentContainer: ContentContainer,
        protected dealerKey: string,
        protected config: Config,
        protected tracker: ITrackingService,
        protected iframeProvider: IIframeProvider,
        protected options: Options,
        protected trackerId: string
    ) {}
    
    abstract inject(): void;

    swapCalculatorForScreening(calculatorData?: CalculatorData): void {
        if (this.contentContainer.productType !== ProductType.CALCULATOR) {
            return;
        }

        ModalCoordinator.getInstance().swapToScreening(
            this.dealerKey,
            this.options,
            this.contentContainer,
            this.iframeProvider,
            calculatorData
        );
    }
}
